"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebConfigStore = exports.WebConfigState = void 0;
const GenUtil_1 = require("../../base/cutil/GenUtil");
const Lazyload_1 = require("../../base/cutil/Lazyload");
const ReadyStatus_1 = require("../../base/cutil/ReadyStatus");
const StoreBase_1 = require("../../base/cutil/StoreBase");
const ImagicaCreatorPlan_1 = require("../webconfig/domain/ImagicaCreatorPlan");
const JsonUtil_1 = require("../../base/cutil/JsonUtil");
const ImagicaFeature_1 = require("../webconfig/domain/ImagicaFeature");
const WebConfigLocal_json_1 = __importDefault(require("../webconfig/domain/WebConfigLocal.json"));
const ImagicatPublishSetting_1 = require("../webconfig/domain/ImagicatPublishSetting");
const StaticLinksType_1 = require("../webconfig/domain/StaticLinksType");
const ImagicaTermsPopup_1 = require("../webconfig/domain/ImagicaTermsPopup");
const ImagicaEngineList_1 = require("../webconfig/domain/ImagicaEngineList");
const imagica_onboarding_video_guide_1 = require("../webconfig/domain/imagica_onboarding_video_guide");
class WebConfigState {
    constructor() {
        this.response = {};
        /**
         * 数据加载状态
         */
        this.readyStatus = ReadyStatus_1.ReadyStatus.PENDING;
        /**
         * 第一次加载，用于做骨架屏
         */
        this.initLoading = true;
        /**
         * 是否禁用了 templates
         */
        this.disabled = true;
        // other data
        this.templates = [];
        this.exampleVideos = [];
        this.cot = {};
        this.cot_v2 = {};
        this.functionGroupConfig = [];
        this.imagica_creator_stripe_subscription_management_link = "";
        this.imagica_creator_subscribe_success = [];
        this.imagica_creator_plans = [];
        this.imagica_features = [];
        this.imagicaAppTemplates = [];
        this.imagicaAppfonts = [];
        this.imagicaCreatorDowngradePlanPopup = {};
    }
}
exports.WebConfigState = WebConfigState;
class WebConfigStore extends StoreBase_1.StoreBase {
    constructor(fotClient) {
        super(() => new WebConfigState());
        this.fotClient = fotClient;
        this.lazyload = new Lazyload_1.Lazyload(() => {
            const state = GenUtil_1.GenUtil.copyWith(new WebConfigState(), this.state, { readyStatus: ReadyStatus_1.ReadyStatus.LOADING });
            this.emit(state);
            return this.fotClient.webConfigApi
                .fetchWebConfig()
                .then(x => {
                /// subscription 相关
                const imagica_creator_stripe_subscription_management_link = x.studios.imagica_creator_stripe_subscription_management_link ||
                    WebConfigLocal_json_1.default.studios.imagica_creator_stripe_subscription_management_link;
                const imagica_creator_subscribe_success = x.studios.imagica_creator_subscribe_success || WebConfigLocal_json_1.default.studios.imagica_creator_subscribe_success;
                const imagica_creator_plans = JsonUtil_1.JsonUtil.toArrayFromType(ImagicaCreatorPlan_1.ImagicaCreatorPlan, x.studios.imagica_creator_plans || WebConfigLocal_json_1.default.studios.imagica_creator_plans) || [];
                const imagica_features = JsonUtil_1.JsonUtil.toArrayFromType(ImagicaFeature_1.ImagicaFeature, x.studios.imagica_features || WebConfigLocal_json_1.default.studios.imagica_features) || [];
                const templates = x.studios.templates || WebConfigLocal_json_1.default.studios.templates;
                const exampleVideos = x.studios.example_videos || WebConfigLocal_json_1.default.studios.example_videos;
                const cot = x.studios.cot || WebConfigLocal_json_1.default.studios.cot;
                const cot_v2 = x.studios.cot_v2;
                const functionGroupConfig = x.studios.function_group_config || WebConfigLocal_json_1.default.studios.function_group_config;
                const imagicaAppTemplates = x.studios.imagica_app_templates || WebConfigLocal_json_1.default.studios.imagica_app_templates;
                const imagicaAppfonts = x.studios.imagica_app_fonts || WebConfigLocal_json_1.default.studios.imagica_app_fonts;
                const imagicaCreatorDowngradePlanPopup = x.studios.imagica_creator_downgrade_plan_popup || WebConfigLocal_json_1.default.studios.imagica_creator_downgrade_plan_popup;
                const imagica_publish_setting = JsonUtil_1.JsonUtil.toModelFromType(ImagicatPublishSetting_1.ImagicaPublishSetting, x.studios.imagica_publish_setting?.link || WebConfigLocal_json_1.default.studios.imagica_publish_setting);
                const static_links = JsonUtil_1.JsonUtil.toModelFromType(StaticLinksType_1.StaticLinksType, x.studios.static_links || WebConfigLocal_json_1.default.studios.static_links);
                const imagica_terms_popup = JsonUtil_1.JsonUtil.toModelFromType(ImagicaTermsPopup_1.ImagicaTermsPopup, x.studios.imagica_terms_popup || WebConfigLocal_json_1.default.studios.imagica_terms_popup);
                const engineList = JsonUtil_1.JsonUtil.toModelFromType(ImagicaEngineList_1.EngineListItem, x.studios.engine_list || WebConfigLocal_json_1.default.studios.engine_list);
                const imagica_onboarding_video_guide = JsonUtil_1.JsonUtil.toModelFromType(imagica_onboarding_video_guide_1.ImagicaOnboardingVideoGuide, x.studios.imagica_onboarding_video_guide || WebConfigLocal_json_1.default.studios.imagica_onboarding_video_guide);
                console.log("setting: setting");
                const state = GenUtil_1.GenUtil.copyWith(new WebConfigState(), this.state, {
                    response: x,
                    readyStatus: ReadyStatus_1.ReadyStatus.DONE,
                    initLoading: false,
                    imagica_creator_stripe_subscription_management_link,
                    imagica_creator_subscribe_success,
                    imagica_creator_plans,
                    imagica_features,
                    templates,
                    exampleVideos,
                    cot,
                    cot_v2,
                    functionGroupConfig,
                    imagicaAppTemplates,
                    imagicaAppfonts,
                    imagicaCreatorDowngradePlanPopup,
                    imagica_publish_setting,
                    static_links,
                    imagica_terms_popup,
                    engineList,
                    imagica_onboarding_video_guide,
                });
                this.emit(state);
                return state;
            })
                .catch(error => {
                console.error("get webconfig error::", error);
                const state = GenUtil_1.GenUtil.copyWith(new WebConfigState(), this.state, { readyStatus: ReadyStatus_1.ReadyStatus.DONE });
                this.emit(state);
                return state;
            });
        });
    }
    async renew() {
        return this.lazyload.renew();
    }
    async get() {
        return this.lazyload.get();
    }
    async templates() {
        return await this.get().then(x => x.templates);
    }
    async exampleVideos() {
        return await this.get().then(x => x.exampleVideos);
    }
    async cot() {
        return await this.get().then(x => x.cot);
    }
    async cot_v2() {
        return await this.get().then(x => x.cot_v2);
    }
    async functionGroupConfig() {
        return await this.get().then(x => x.functionGroupConfig);
    }
    async stripeManagementLink() {
        return this.get().then(x => x.imagica_creator_stripe_subscription_management_link);
    }
    async subscribeSuccessContent() {
        return this.get().then(x => x.imagica_creator_subscribe_success);
    }
    async imagicaCreatorPlans() {
        return this.get().then(x => x.imagica_creator_plans);
    }
    async imagicaFeatures() {
        return this.get().then(x => x.imagica_features);
    }
    async imagicaAppTemplates() {
        return await this.get().then(x => x.imagicaAppTemplates);
    }
    async imagicaAppfonts() {
        return await this.get().then(x => x.imagicaAppfonts);
    }
    async imagicaCreatorDowngradePlanPopup() {
        return this.get().then(x => x.imagicaCreatorDowngradePlanPopup);
    }
}
exports.WebConfigStore = WebConfigStore;
